var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fetching-group",class:{'mini' : _vm.mini}},[_c('span',{staticClass:"fetching"}),(!_vm.mini)?_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('p',{key:_vm.current,staticClass:"message"},[_vm._v(_vm._s(_vm.current))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }